import { PageCriteriaDTO } from '@data/common/pagination/PageCriteriaDTO';
import { Transform } from 'class-transformer';
import { DateUtil } from '@shared/util/date.util';

export class PatientNotePageCriteriaDTO extends PageCriteriaDTO {
  @Transform(DateUtil.dateConversion)
  public from: Date;

  @Transform(DateUtil.dateConversion)
  public to: Date;
}
